import { render } from "./Fum.vue?vue&type=template&id=cc151a7a&ts=true"
import script from "./Fum.vue?vue&type=script&lang=ts"
export * from "./Fum.vue?vue&type=script&lang=ts"

import "./Fum.vue?vue&type=style&index=0&id=cc151a7a&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__